import { ComponentProps, PropsWithChildren, Suspense } from 'react';
import styled from 'styled-components';

import { lazy } from 'lib/retry';

const Root = styled.div`
  position: relative;
  isolation: isolate;
`;
const ShaderWrapper = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

const Silk = lazy(async () =>
  import('@sorare/trois/src/components/SilkBackground').then(module => ({
    default: module.SilkBackground,
  }))
);

export const SilkBackground = ({
  children,
  color,
  ...rest
}: Omit<PropsWithChildren<React.JSX.IntrinsicElements['div']>, 'color'> &
  ComponentProps<typeof Silk>) => {
  return (
    <Root {...rest}>
      <ShaderWrapper>
        <Suspense fallback={null}>
          <Silk fallback={null} color={color} />
        </Suspense>
      </ShaderWrapper>
      {children}
    </Root>
  );
};
